// Module
var code = `<div class="login-page">
  <div class="login-card">

    <div class="login-brand">
      <i class="fas fa-tv fa-3x login-mark" aria-hidden="true"></i>
      <span class="jumbotron-kind-label">Welcome to</span>
      <h1 class="jumbotron-title login-name">JumboTRON</h1>
      <p class="jumbotron-note login-tagline">Real-time content for the big screens at Roskilde Festival</p>
    </div>

    <div class="jumbotron-surface login-surface">
      <div class="jumbotron-panel-head">
        <span class="jumbotron-heading">Sign in</span>
      </div>

      <div class="login-body">
        <p class="jumbotron-note login-lead">Sign in with your Roskilde Festival account to continue.</p>

        <div ng-if="\$ctrl.error" class="alert alert-danger py-2 mb-0" role="alert">
          <i class="fas fa-exclamation-circle me-1" aria-hidden="true"></i> {{ \$ctrl.error }}
        </div>

        <div class="d-grid">
          <button type="button" class="btn btn-sm btn-primary" ng-disabled="\$ctrl.working"
            ng-click="\$ctrl.signIn()">
            <span ng-if="!\$ctrl.working"><i class="fab fa-microsoft me-2" aria-hidden="true"></i>Sign in with
              Microsoft</span>
            <span ng-if="\$ctrl.working"><i class="fas fa-circle-notch fa-spin me-2"
                aria-hidden="true"></i>Redirecting...</span>
          </button>
        </div>
      </div>
    </div>

    <p class="jumbotron-note login-footer">&copy; Roskilde Festival</p>
  </div>
</div>
`;
// Exports
export default code;